import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const AffordabilityCalculatorTitleWrapper = ({ children = null, fontSize = 14 }) => (
  <span className={classNames(`fw-bold size-${fontSize}`)}>{children}</span>
);

AffordabilityCalculatorTitleWrapper.propTypes = {
  children: PropTypes.node,
  fontSize: PropTypes.number,
};
